import React, {useState, useCallback} from 'react';
import {View, StyleSheet, TouchableOpacity} from 'react-native';
import {Text, TextInput} from 'react-native-paper';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import CountryPickerModal from '../CountryPickerModal';
import {colors, spacing} from '../../theme';

const getFlag = code =>
  String.fromCodePoint(
    ...code.toUpperCase().split('').map(c => 127397 + c.charCodeAt()),
  );

// Maps common dial codes to ISO codes for flag display
const DIAL_TO_ISO = {
  '+91': 'IN', '+1': 'US', '+44': 'GB', '+971': 'AE', '+966': 'SA',
  '+65': 'SG', '+60': 'MY', '+61': 'AU', '+49': 'DE', '+33': 'FR',
  '+81': 'JP', '+86': 'CN', '+82': 'KR', '+62': 'ID', '+66': 'TH',
  '+880': 'BD', '+92': 'PK', '+94': 'LK', '+977': 'NP',
};

const PhoneInput = ({
  countryCode = '+91',
  onCountryCodeChange,
  phone,
  onPhoneChange,
  label = 'Phone Number',
  disabled = false,
  error = false,
  style,
}) => {
  const [pickerVisible, setPickerVisible] = useState(false);
  const [isoCode, setIsoCode] = useState(DIAL_TO_ISO[countryCode] || 'IN');

  const handleCountrySelect = useCallback(country => {
    onCountryCodeChange(country.dialCode);
    setIsoCode(country.code);
  }, [onCountryCodeChange]);

  return (
    <View style={[styles.container, style]}>
      <TouchableOpacity
        style={[styles.countryButton, error && styles.countryButtonError]}
        onPress={() => setPickerVisible(true)}
        disabled={disabled}>
        <Text style={styles.flag}>{getFlag(isoCode)}</Text>
        <Text style={styles.dialCode}>{countryCode}</Text>
        <Icon name="chevron-down" size={16} color={colors.textSecondary} />
      </TouchableOpacity>

      <TextInput
        label={label}
        value={phone}
        onChangeText={onPhoneChange}
        keyboardType="phone-pad"
        mode="outlined"
        style={styles.phoneInput}
        disabled={disabled}
        error={error}
        outlineColor={colors.border}
        activeOutlineColor={colors.primary}
      />

      <CountryPickerModal
        visible={pickerVisible}
        onClose={() => setPickerVisible(false)}
        onSelect={handleCountrySelect}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: spacing.sm,
  },
  countryButton: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: colors.border,
    borderRadius: 4,
    paddingHorizontal: 10,
    height: 56,
    marginRight: 8,
  },
  countryButtonError: {
    borderColor: colors.error,
  },
  flag: {fontSize: 18, marginRight: 3},
  dialCode: {fontSize: 14, color: colors.text, marginRight: 2},
  phoneInput: {flex: 1, backgroundColor: colors.surface},
});

export default PhoneInput;
